import React, { Fragment } from 'react';
import messages from './Messages';
import { display } from 'components/ErrorView/ErrorDialog';
import i18n from 'i18n';
import Select from 'components/Select';
import { IOption } from 'components/Select/Select';

interface ITaskSearchProviderProps {
  onSearch: (searchTerm: string) => Promise<any>;
  onSelect: (itemId: number | string) => void;
  placeholder?: string;
}

interface ITaskSearchProviderState {
  loading: boolean;
  inputValue: string;
  searchResult: any[];
}

interface IAutocompleteItem {
  id: number | string;
  title: string;
  archived: boolean;
}

class TaskSearch extends React.PureComponent<
  ITaskSearchProviderProps,
  ITaskSearchProviderState
> {
  state = {
    loading: false,
    inputValue: '',
    searchResult: [],
  };

  timer: any;

  handleChangeInput = (searchTerm: string) => {
    clearTimeout(this.timer);

    this.setState({ inputValue: searchTerm });

    if (searchTerm !== '' && searchTerm.length > 2) {
      this.timer = setTimeout(this.triggerTaskSearch, 300);
    }
  };

  handleSelectATask = (optionsList: IOption[]) => {
    const selected = optionsList[0];
    const selectedId = selected ? Number(selected.value) : undefined;
    if (selectedId && selectedId !== -1) {
      this.setState({ inputValue: '', searchResult: [] });
      this.props.onSelect(selectedId);
    }
  };

  triggerTaskSearch = () => {
    this.setState({ loading: true });
    this.props
      .onSearch(this.state.inputValue)
      .then((searchResult: { tasks: IAutocompleteItem[] }) => {
        if (searchResult.tasks.length > 0) {
          this.setState({ searchResult: searchResult.tasks, loading: false });
        } else {
          this.setState({
            searchResult: [{ id: -1, title: messages.noItemFound }],
            loading: false,
          });
        }
      })
      .catch((err) => {
        display(err);
        this.setState({ loading: false });
      });
  };

  render() {
    const { searchResult } = this.state;

    const searchOptions = searchResult.map((item: IAutocompleteItem) => ({
      value: item.id.toString(),
      label: item.title,
    }));

    return (
      <Fragment>
        <Select
          placeholder={i18n.t('searchTask', { ns: 'taskManager' }) as string}
          options={searchOptions}
          onSearch={this.handleChangeInput}
          onChangeValues={this.handleSelectATask}
          multiChoice={false}
          allowRemove={false}
          values={[]}
        />
      </Fragment>
    );
  }
}
export default TaskSearch;
